import { Device } from '../../../models/Devices';

export const saveDevices = (devices: Device[]) => {
    const storage = {
        devices: devices,
    };
    localStorage.setItem('devices', JSON.stringify(storage));
};

export const saveDevice = (device: Device) => {
    const storage = {
        device: device,
    };
    localStorage.setItem('device', JSON.stringify(storage));
};
export const retrieveDevices = (): {
    devices: Device[];
} => {
    const storage = localStorage.getItem('devices') || '';
    return JSON.parse(storage);
};

export const retrieveDevice = (): {
    device: Device;
} => {
    const storage = localStorage.getItem('device') || '';
    return JSON.parse(storage);
};
